import React from 'react';
import { siteContent } from '../data/mock';

const Footer = () => {
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-branding">
            <img 
              src="https://customer-assets.emergentagent.com/job_2b6151a4-b955-4140-b173-879b68f4ed03/artifacts/bkqihzxr_image.png" 
              alt="Inspire Therapy Collective"
              className="footer-logo-badge"
            />
            <div>
              <h3 className="heading-3 font-serif">{siteContent.footer.practiceName}</h3>
              <p className="body-small">{siteContent.footer.therapist}</p>
              <p className="caption">{siteContent.footer.location}</p>
            </div>
          </div>

          <div className="footer-social">
            <a href="#" className="social-link" aria-label="Instagram">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/>
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
                <circle cx="18" cy="6" r="1" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" className="social-link" aria-label="LinkedIn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z" 
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 9H2V21H6V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-badges">
          <a href="/step-up-scholarship" className="footer-badge-row" data-testid="step-up-badge-footer">
            <img 
              src="https://customer-assets-7cd3h4nn.emergentagent.net/job_50e26051-612f-4752-a7df-90e8e02588f2/artifacts/pxsfg4tg_IMG_9986.jpeg" 
              alt="Step Up For Students logo" 
              className="step-up-badge-img-sm"
            />
            <span className="caption violet-footer-label">Approved Provider — Step Up For Students EMA Marketplace</span>
          </a>
          <a href="https://www.joinviolet.com" target="_blank" rel="noopener noreferrer" className="violet-badge-link footer-violet" data-testid="violet-badge-footer">
            <img 
              src="https://app.joinviolet.com/api/v1/users/ZjcxNzc3Y2QtMWJhMy00ZDE3LWIzNjQtN2I3N2U5ODRiNjRk/benchmark_image?communities=neurodivergence" 
              alt="Violet Verified — Neurodivergence Cultural Awareness" 
              className="violet-badge-img-sm"
            />
            <span className="caption violet-footer-label">Violet Verified — Neurodivergence Cultural Awareness (2026)</span>
          </a>
        </div>

        <div className="footer-links">
          <a href="/refer-a-family" className="footer-partner-link" data-testid="footer-refer-link">For Partners</a>
          <a href="/fees-documentation" className="footer-partner-link">Fees & Documentation</a>
          <a href="/step-up-scholarship" className="footer-partner-link" data-testid="footer-step-up-link">Step Up Scholarship</a>
        </div>

        <div className="footer-crisis">
          <p className="caption">
            If you are in crisis or need immediate help, please call or text <a href="tel:988">988</a> (Suicide & Crisis Lifeline) or call <a href="tel:911">911</a>. This practice does not provide emergency services.
          </p>
        </div>

        <div className="footer-copyright">
          <p className="caption">{siteContent.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
